import {
  Box, Checkbox, Divider, FormControl, FormControlLabel,
  Grid, Paper, Stack, Typography, useTheme, useMediaQuery
} from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { TextFieldMask } from '../../../utils/TextfieldMask/TextfieldMask';
import { poolFacilidades } from '../../../constants/places';

export const Caracteristicas2 = ({ setPlaceEdit, placeEdit, setNewPlace, newPlace }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [caracteristica, setCaracteristica] = useState(placeEdit);

  useEffect(() => {
    setPlaceEdit(caracteristica);
  }, [caracteristica]);


  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      sx={{
        width: '100%',
        p: 0
      }}
    >
      <Stack spacing={3}>
        {/* Specifications Section */}
        <Paper
          elevation={2}
          sx={{ p: 2, borderRadius: 2 }}
        >
          <Stack spacing={2}>
            <Typography variant="h4" color="primary" fontWeight="medium">
              Especificações Gerais
            </Typography>
            <Stack
              direction='row'
              gap={{ xs: 2, sm: 0 }}
              sx={{
                flexWrap: 'wrap',
                justifyContent: 'space-between'
              }}
            >

              <TextFieldMask
                label="Dorm. De"
                value={caracteristica.quartosqtdmin}
                onChange={(e) => setCaracteristica({ ...caracteristica, quartosqtdmin: e.target.value })}
                onBlur={(e) => setCaracteristica({ ...caracteristica, quartosqtdmin: e.target.value })}
                mask="number"
                sx={{ width: '100px' }}
                size="small"
                inputProps={{ maxLength: 1 }}
                field="quartosqtdmin"
              />
              <TextFieldMask
                label="Dorm. Até"
                value={caracteristica.quartosqtdmax}
                onChange={(e) => setCaracteristica({ ...caracteristica, quartosqtdmax: e.target.value })}
                onBlur={(e) => setCaracteristica({ ...caracteristica, quartosqtdmax: e.target.value })}
                mask="number"
                sx={{ width: '100px' }}
                size="small"
                inputProps={{ maxLength: 2 }}
                field="quartosqtdmax"
              />
              <TextFieldMask
                label="Área Menor"
                variant="outlined"
                size="small"
                mask="decimal"
                value={caracteristica.minarea || ""}
                onChange={(e) => setCaracteristica({ ...caracteristica, minarea: e.target.value })}
                sx={{ width: '100px' }}
                inputProps={{ maxLength: 6 }}
              />
              <TextFieldMask
                label="Área Maior"
                variant="outlined"
                sx={{ width: '100px' }}
                size="small"
                mask="decimal"
                value={caracteristica.maxarea || ""}
                onChange={(e) => setCaracteristica({ ...caracteristica, maxarea: e.target.value })}
                inputProps={{ maxLength: 6 }}
              />
              <TextFieldMask
                label="Andares"
                value={caracteristica.andares}
                onChange={(e) => setCaracteristica({ ...caracteristica, andares: e.target.value })}
                onBlur={(e) => setCaracteristica({ ...caracteristica, andares: e.target.value })}
                mask="number"
                sx={{ width: '80px' }}
                size="small"
                inputProps={{ maxLength: 2 }}
                field="andares"
                
              />
              <TextFieldMask
                label="Torres"
                value={caracteristica.blocos}
                onChange={(e) => setCaracteristica({ ...caracteristica, blocos: e.target.value })}
                onBlur={(e) => setCaracteristica({ ...caracteristica, blocos: e.target.value })}
                mask="number"
                field="blocos"
                width="80px"
                sx={{ width: '70px' }}
                size="small"
                inputProps={{ maxLength: 1 }}
              />

            </Stack>
          </Stack>
        </Paper>

        {/* Facilities Section */}
        <Paper
          elevation={2}
          sx={{ p: 2, borderRadius: 2 }}
        >
          <Stack spacing={2}>
            <Typography variant="h4" color="primary" fontWeight="medium">
              Facilidades e Comodidades
            </Typography>

            <Box
              sx={{
                maxHeight: '400px',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                },
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{ p: 1 }}
              >
                {poolFacilidades.map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.campo}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={caracteristica?.[item.campo] || false}
                          onChange={(e) => setCaracteristica({
                            ...caracteristica,
                            [item.campo]: e.target.checked
                          })}
                        />
                      }
                      label={
                        <Typography variant="body2">
                          {item.nome}
                        </Typography>
                      }
                      sx={{
                        width: '100%',
                        margin: 0,
                        '& .MuiCheckbox-root': {
                          padding: '4px'
                        }
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};